var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _ellipse2, _path31, _path32, _path33, _path34, _path35, _path36, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path60, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiddenOwl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs43"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15538",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15540",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15542",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15544",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15546",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15548",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-10.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15550",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15552",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-87.06)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15554",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15556",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-67.26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15558",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15560",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-64.27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15562",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15564",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-12.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15566",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15568",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-17.63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15570",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15572",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15574",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15576",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-84.857)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15578",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15580",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15582",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15584",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15586",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15588",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15590",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15592",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15594",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15596",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15598",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15600",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15602",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15604",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15606",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15608",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15610",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15612",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15614",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15616",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15618",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15620",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15622",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15624",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15626",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15628",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15630",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15632",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15634",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15636",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15638",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15640",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15642",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15644",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15646",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15648",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15650",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15652",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15654",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15656",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15658",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15660",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15662",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15664",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15666",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15668",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15670",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15672",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15674",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15676",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15678",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15680",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15682",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15684",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15686",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15688",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15690",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15692",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15694",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15696",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15698",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15700",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15702",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15704",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15706",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15708",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15710",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15712",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15714",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15716",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15718",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15720",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15722",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15724",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-46.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15726",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15728",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    },
    transform: "scale(-1 1) rotate(-40.38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15730",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15732",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15734",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15736",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15738",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15740",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15742",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15744",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15746",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15748",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15750",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15752",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15754",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15756",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15758",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15760",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15762",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15764",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15766",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15768",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15770",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15772",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15774",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15776",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15778",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15780",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15782",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15784",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15786",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15788",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15790",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15792",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15794",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15796",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15798",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15800",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15802",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15804",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15806",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15808",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15810",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15812",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15814",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15816",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15818",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15820",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15822",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15824",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15826",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15828",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15830",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15832",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15834",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15836",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15838",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15840",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15842",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15844",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15846",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15848",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15850",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect15852",
    d: "M173.589 34.255h802.499v570.407H173.589z",
    style: {
      fill: "#7a5c37",
      fillOpacity: 1
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style41"
  }, ".cls-2{fill:#f2b040}.cls-3{fill:#add9d3}.cls-4{fill:#77bfb6}.cls-5{fill:#fff}.cls-6{fill:#efe0cc}.cls-7{fill:#ddcdba}.cls-8{fill:#c6b39d}.cls-9{fill:#af9880}.cls-10{fill:#231c51}.cls-11{fill:#2f2f2f}"))), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m241.945 832.34 4.2 17.59.57 2.4 4 16.87.56 2.35 7.09 29.69.79 3.32 3.19 13.38 4.4.83 3.29.62 57 10.72 2.82.53 36.7 6.9 3.75.71 18.48 3.48-93.39 25.83 26.26 33.07 36.46-7.89 3-.65 23.94-5.18 3.44-.75 61.4-13.29 2.42-.53 7.72-1.66 2.44-.53 15.42-3.34 2.5-.54 47.55-10.27 9.84 2.46 2.94.74 22.1 5.53 2.48.62 22.94 5.74 2.61.66 54.31 13.6 3 .76 22.66 5.67 2.35.59 35.81 9 2.45.61 22.14 5.54 2.82.71 140.72 35.24-5.79-24.64-1.2-5.08-11.09-47.65-.6-2.55-4.16-17.73-.58-2.46-5.54-23.6-.56-2.39-7.24-30.8-12.21-1.1-3.34-.31-54.44-4.93h-.21l-6.84-.62-52.31-4.74-8.59-.78-19.14-1.73-43.4-3.93-7.92-.72-38.25-3.47-2.72-.24-35.78-3.24-2.5-.23-46.06-4.17-1.56-.14-4.73-.43-11.85-1.07-2.63-.24-15.69-1.48-18.92-1.71-2.4-.22-23-2.09-15.59-8.67-2.86-1.6-32.12-17.87-2.56-1.43-16.07-8.94-3.9-2.17-12.64-7-3.19-1.77-31.7-17.64-15.56 11.67 5.9 6.44 1.83 2 23.33 25.46 1.68 1.83 10.34 11.27-19.36-1.76-4.33-.39-14.51-1.31-2.49-.22-19.94-1.81-2.67-.24z",
    clipPath: "url(#clipPath15850)",
    style: {
      fill: "#f6c357"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M485.815 854.44a73.6 73.6 0 0 0 7.53 17.08c5.51 8.81 13.53 14.53 22.9 18.74 8.55 3.84 17.9 8.24 27.43 9.23a35 35 0 0 0 4.22.21c21.47-.2 35.19-19.16 45.75-35.5l-2.72-.24c-5.69 8.82-11.69 17.67-20 24.25-8.09 6.43-18.15 10.27-28.57 8.65-.75-.12-1.5-.25-2.25-.41a80.07 80.07 0 0 1-12.88-4.21c-4.8-1.92-9.63-3.83-14.22-6.2a44.83 44.83 0 0 1-20-20 78.33 78.33 0 0 1-4.61-11.37z",
    className: "cls-2",
    clipPath: "url(#clipPath15846)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M500.305 855.75a48 48 0 0 1 6 4.75 59.11 59.11 0 0 1 6.59 7.21c4.3 5.53 7.48 14.17 15.15 15.63 7.15 1.36 14.15-3.17 18.74-8.24a40.55 40.55 0 0 0 8.37-14.39l-2.5-.23a37.64 37.64 0 0 1-8.13 13.52c-4.6 4.88-12.89 9.91-19.44 5.6-3.17-2.08-4.94-5.71-7-8.76a74.76 74.76 0 0 0-6.39-8.29 55.68 55.68 0 0 0-5.18-5.09c-.49-.43-1-.84-1.48-1.24z",
    className: "cls-2",
    clipPath: "url(#clipPath15842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M582.035 908.78a61.45 61.45 0 0 1 22.28-10.31c8.69-2.18 17.62-2.2 26.51-2.32 8.89-.12 18.23-1 27.1.23a25.31 25.31 0 0 1 11.36 4.37 15.16 15.16 0 0 1 6.14 9.1c1.45 6.74-3.75 14.09-11 12.89a17.08 17.08 0 0 0-5.87 1.61 16.15 16.15 0 0 0-4.75 3.44c-2.28 2.4-3.27 5.07-6.91 5.47-8.39.92-17-1.88-24.5-5.3-4-1.83-8-3.93-12.27-5.1a20.2 20.2 0 0 0-13.21.87c-5.72 2.21-13.08 5.46-18.53.69-5.62-4.93-.98-12.08 3.65-15.64zm2.87 15.63c6.67.52 12.36-4.58 19-4.8 6.9-.23 13.22 3.28 19.3 6.07a62.91 62.91 0 0 0 12 4.24 40.28 40.28 0 0 0 6.55 1c1.9.11 4.78.47 6.5-.48 1.5-.83 2.36-2.82 3.5-4.07a18.91 18.91 0 0 1 3.59-3 18.28 18.28 0 0 1 4.47-2.12 20.82 20.82 0 0 1 4.72-.91 1.09 1.09 0 0 1 .63.13c3.45.42 6.61-2.19 7.65-5.4 1.04-3.21-.11-6.7-2-9.32a14.72 14.72 0 0 0-2.58-2.75c-4.76-3.87-11.48-4.55-17.53-4.61-7.72-.06-15.45.17-23.17.27-7.87.1-15.72.36-23.38 2.39a62.62 62.62 0 0 0-19.53 8.87c-2.83 2-6.51 5.15-6.41 9 .09 3.52 3.54 5.25 6.7 5.49z",
    className: "cls-2",
    clipPath: "url(#clipPath15838)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m460.035 970.68 2.44-.53a107.75 107.75 0 0 1 2.59-20.7 103.52 103.52 0 0 1 12.42-31.33c6.79-11.06 20.06-2.86 26.92 3.52 3.6 3.35 6.92 7 10.48 10.37 3.56 3.37 7 6.46 10.45 9.81 5 4.9 9.71 10.27 12.47 16.62l2.94.74c-3.2-8.64-9.92-15.59-16.61-21.87-3.91-3.67-7.89-7.26-11.65-11.08-3.76-3.82-7.39-7.63-11.67-10.76-3.93-2.86-8.48-5-13.4-5.15-5.51-.16-9.45 2.26-12.22 6.9a109.55 109.55 0 0 0-15.16 53.46z",
    className: "cls-2",
    clipPath: "url(#clipPath15834)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m477.875 966.82 2.5-.54a67.9 67.9 0 0 1 5.88-20.6c.75-1.53 1.56-3.14 3.34-3.62a11.79 11.79 0 0 1 4.93.08 19.52 19.52 0 0 1 15.51 16.25c.22 1.55 2.56.89 2.34-.65a21.66 21.66 0 0 0-9.45-14.7c-4-2.72-12-5.74-16.32-2.17-2.32 1.91-3.45 5.51-4.49 8.22a69.85 69.85 0 0 0-3.25 11.59c-.38 2.04-.71 4.09-.99 6.14z",
    className: "cls-2",
    clipPath: "url(#clipPath15830)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "M391.805 892.08a7.42 7.42 0 0 1 3.79-5.43c5.32-3.26 12.57-2.34 18.4-1.43 7.94 1.24 15.65 3.75 23.65 4.64 3.92.44 7.76.11 11.68.14 3.08 0 6.38.41 8.87 2.4 5.75 4.6 3 12.7.5 18.27a1.38 1.38 0 0 1-.15.25c-2.1 4.95-7.14 8-12.36 9a48.72 48.72 0 0 1-11.72.28c-2-.11-4-.29-5.94-.22-2.53.09-3.69 1.22-4.84 3.32a13.31 13.31 0 0 1-13.25 7.07c-5.77-.55-10.33-4.61-12.55-9.82a20.34 20.34 0 0 1-1.57-9c.2-4.13 1.05-7.88-1.32-11.6-1.52-2.48-3.49-4.84-3.19-7.87zm5.5 6.87c3.35 5.44.56 11.38 1.77 17.24 1.1 5.35 4.83 10.49 10.45 11.56a12 12 0 0 0 7.62-1c2.47-1.26 3.57-3.28 4.94-5.55 3.47-5.77 11.42-3.32 17-3.22 6.79.12 15.51-1.57 17.64-9.15a1.18 1.18 0 0 1 .42-.63c2.1-5.07 4-12.5-2.42-15-2.38-.91-5-.81-7.55-.73a67.84 67.84 0 0 1-9.11-.13c-6.24-.63-12.31-2.25-18.42-3.57-6.11-1.32-12.95-2.83-19.1-1.46-2.28.51-5.21 1.63-6.11 4-1.06 2.85 1.49 5.4 2.87 7.63z",
    className: "cls-2",
    clipPath: "url(#clipPath15826)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "M336.905 799.53q1.38 4 2.88 8c3 7.91 5.81 16.41 12.72 21.78 6.39 5 14.7 7.4 22.44 9.27a106.53 106.53 0 0 0 27.68 3 26.55 26.55 0 0 0 7.63-1.25l-2.86-1.6c-3.87.77-8.05.51-11.91.33a106.22 106.22 0 0 1-25.58-4.38c-7.32-2.2-15.14-5.1-20-11.34-2.52-3.26-4.11-7.12-5.63-10.92-1.52-3.8-2.87-7.38-4.19-11.12z",
    className: "cls-2",
    clipPath: "url(#clipPath15822)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "M352.725 808.32c2.18 4.05 4.14 8.26 7.81 11.17a13.56 13.56 0 0 0 14.73 1.37l-2.56-1.43a10.76 10.76 0 0 1-3.65.62c-4.19 0-7.57-2.34-10-5.62a38.82 38.82 0 0 1-2.47-3.94z",
    className: "cls-2",
    clipPath: "url(#clipPath15818)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "M309.035 838.42q2.82 2.39 5.76 4.61c21.43 16.25 47.75 28.4 74.55 31.82 13.73 1.76 28.32 1.11 41.44-3.62 9.2-3.32 18.37-10.27 20.46-19.91l-2.4-.22c-2.61 12-17.07 18.12-28.38 20.45-26.44 5.46-54-2.27-77.64-14.08a166.57 166.57 0 0 1-29.47-18.64z",
    className: "cls-2",
    clipPath: "url(#clipPath15814)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M295.575 800a25.16 25.16 0 0 1 16.66.36c5.24 2 10.63 5.87 12.35 11.44 1.59 5.12 1.33 11.92-1.55 16.56-.2.32-.4.62-.62.9l-1.68-1.83a9.22 9.22 0 0 0 .54-.88 19.06 19.06 0 0 0 .61-15.08c-2-4.73-7.27-7.94-12-9.34a22.8 22.8 0 0 0-12.46-.14z",
    className: "cls-2",
    clipPath: "url(#clipPath15810)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m358.175 992.73 3-.65c.3-.57.61-1.13.94-1.69 8.8-15.13 24.41-24.91 41.44-28.05a68.2 68.2 0 0 1 27.9.68c5.64 1.32 15.5 3.85 18.5 9.85l2.42-.53c-3.1-7.05-13.56-10.09-20.28-11.67-18.93-4.46-40.16-1-55.92 10.67a59 59 0 0 0-18 21.39z",
    className: "cls-2",
    clipPath: "url(#clipPath15806)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m385.125 986.9 3.44-.75 1.78-2.62c2.74-4 5.15-8.39 9.91-10.28a39.88 39.88 0 0 1 15-3.09c5.2.13 10.17 2 15 3.72 1.48.53 2.11-1.81.65-2.34-5.32-1.93-10.81-3.88-16.55-3.81a42.57 42.57 0 0 0-15.45 3.49c-4.46 1.89-6.92 5.63-9.54 9.49z",
    className: "cls-2",
    clipPath: "url(#clipPath15802)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m258.395 901.24.79 3.32q.8-1.34 1.66-2.63a34.75 34.75 0 0 1 13.78-12.53c6.31-3 13.45-3.86 20.37-3.65 15.66.47 30.46 6.69 46.07 7.72 7.65.5 15.75-.2 22.9 3.05a27.32 27.32 0 0 1 13.17 13.11c3.1 6.53 3.72 15-1.08 20.85a28.19 28.19 0 0 1-9.44 7l3.75.71a25.93 25.93 0 0 0 8.41-7.33c4.42-6.29 3.85-14.76.89-21.54a29.69 29.69 0 0 0-12.91-14.15c-7-3.77-14.88-3.73-22.59-4-17.09-.64-33.22-7.69-50.34-7.9-7.11-.08-14.34 1-20.76 4.17a36.89 36.89 0 0 0-13.94 12.68c-.26.39-.5.76-.73 1.12z",
    className: "cls-2",
    clipPath: "url(#clipPath15798)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m266.775 918.77 3.29.62c8.69-6.44 18.46-11 29.77-10.61a110.59 110.59 0 0 1 14.08 1.61c4 .67 8.17 1.6 11.7 3.76 4.06 2.49 7.38 6.9 5.05 11.74a11.6 11.6 0 0 1-3.58 4.22l2.82.53c3.33-3 5.35-7 3.22-11.86-2.82-6.45-10.31-9.16-16.71-10.4-8-1.55-16.62-2.84-24.73-1.58-9.33 1.45-17.53 6.14-24.91 11.97z",
    className: "cls-2",
    clipPath: "url(#clipPath15794)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m250.745 869.2.56 2.35a21.86 21.86 0 0 0 7.38-3c3.25-2.11 5.59-4.76 9.8-4.55 3.24.17 6.23.93 9.49.44a21.07 21.07 0 0 0 7.89-2.92 19.38 19.38 0 0 0 9.17-13.46 32.06 32.06 0 0 0-.46-11l-2.49-.22c1.26 5.6 1.42 11.51-1.31 16.3a18.47 18.47 0 0 1-18 8.92c-3.88-.44-7.32-1.05-10.82 1.14-3.14 2-5.66 4.35-9.3 5.47-.62.23-1.28.39-1.91.53z",
    className: "cls-2",
    clipPath: "url(#clipPath15790)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m246.145 849.93.57 2.4a37.55 37.55 0 0 0 25.4-17.26l-2.67-.24a34.77 34.77 0 0 1-23.3 15.1z",
    className: "cls-2",
    clipPath: "url(#clipPath15786)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m562.815 964.71 2.48.62a92.63 92.63 0 0 1 6.2-7c8.36-8.49 18.82-15.36 30.62-17.78 13.74-2.82 27.39 1.7 39.85 7.21 10.83 4.79 24.91 9.74 29.44 21.8 2.69 7.15 2 15-.53 22.19l2.35.59c2.94-8.62 3.45-18.1-.73-26.3-2.86-5.59-7.81-9.59-13.17-12.63a183.51 183.51 0 0 0-19-9c-12.77-5.41-26.54-9.2-40.37-5.89-15.74 3.78-27.53 13.92-37.14 26.19z",
    className: "cls-2",
    clipPath: "url(#clipPath15782)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m588.235 971.08 2.61.66a37.26 37.26 0 0 1 11.31-9.29c6.75-3.36 13.87-2.9 20.42.66 6.27 3.41 11.36 8.64 16.12 13.86a46.28 46.28 0 0 1 6.45 8.37l3 .76a37.47 37.47 0 0 0-6.38-9.3c-5.41-6.14-11.37-12.39-18.73-16.17a23.7 23.7 0 0 0-21.43-.63c-5.32 2.49-9.57 6.58-13.37 11.08z",
    className: "cls-2",
    clipPath: "url(#clipPath15778)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "M755.545 943.17c4.81 4.4 12.73 3 18.39 1.44 3.55-1 7-2.25 10.61-3.1a33.63 33.63 0 0 1 12.26-.56c8.78 1.11 17.49 2.88 26.26 4.09q6 .83 12.08 1.62c4 .52 8 1.19 12.08.83a25.42 25.42 0 0 0 7-1.66l-.58-2.46a26.63 26.63 0 0 1-12.17 1.63c-8.6-.74-17.21-2.17-25.75-3.44-7.48-1.11-15.06-3-22.62-3.36-6.66-.28-12.75 2-19 3.85a30.6 30.6 0 0 1-10.64 1.55c-3.3-.25-8.61-1.89-7.46-6.28 1-3.65 5.2-6 8.28-7.64a43.78 43.78 0 0 1 8.7-3.45c14.51-4.11 29.7-1.52 44.38 0a43.34 43.34 0 0 0 10.68.2 28.85 28.85 0 0 0 8.75-3.1c3.62-1.8 7-3.24 11-3.57h.32l-.56-2.39a26.08 26.08 0 0 0-4.46.68c-3.87 1-7.2 3.28-10.88 4.75-4.5 1.81-9.24 1.6-14 1.11s-9.31-1.07-14-1.53c-14.82-1.48-31-1.57-44 6.82-4.42 2.86-10.01 9.09-4.67 13.97z",
    className: "cls-2",
    clipPath: "url(#clipPath15774)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "M631.915 867.67c5.24 2.32 10.56 4.49 15.77 6.78l28.35 12.4 2.84 1.25c9.64 4.22 19 8.06 29.73 7.84 5.36-.11 10.84-.78 16.13.41a25.1 25.1 0 0 1 4.71 1.59 47.17 47.17 0 0 1 7.31 4.26c6.94 4.75 13.49 10.2 22.14 11.17 9 1 18.79-1.4 27.36-4a111.84 111.84 0 0 0 41.85-23.85l-3.34-.31a110.14 110.14 0 0 1-22.27 15 107.07 107.07 0 0 1-23.7 8.7c-9.19 2.18-19.36 4-28.17-.43-7.31-3.66-13.16-9.69-20.72-12.91l-.5-.2c-8.8-3.51-18.08-1-27.24-2-8.75-1-17.07-4.84-25.13-8.54-1.78-.82-3.55-1.63-5.31-2.4l-29.42-12.87-2.5-1.07z",
    className: "cls-2",
    clipPath: "url(#clipPath15770)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m284.745 987 1-.39c-.14-12.51-12.7-18.66-23.88-21.78a85.4 85.4 0 0 0-29.08-2.51 60.78 60.78 0 0 0-14.29 3c-2.87 1-4.75 1.59-4.27 2.13l.71.36c14.45 10.61 17.61 18 21.69 22 3.6 4.14 8.11 5 14.35 4.63 12.97-1.7 29.94-5.17 33.77-7.44z",
    className: "cls-3",
    clipPath: "url(#clipPath15766)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "m284.745 987 1-.39c-.14-12.51-12.7-18.66-23.88-21.78a85.4 85.4 0 0 0-29.08-2.51 60.78 60.78 0 0 0-14.29 3c-2.87 1-4.75 1.59-4.27 2.13l.71.36c9 .22 22.79.17 37.22 3.12 14.08 2.71 28.88 8.48 32.59 16.07z",
    className: "cls-4",
    clipPath: "url(#clipPath15762)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "M298.585 992.49c-.51.22-1 .44-1.5.68a113.26 113.26 0 0 0-27.79 20.5c-5.7 6-7.94 10.24-8.53 14.53-.59 4.29.45 8.61 1.23 14.19.82 5.34 1.37 11.91.94 15-.13 2.53-.36 4.1-.35 4.1 8.49-2.28 15.89-7.59 22.44-15.17a81.8 81.8 0 0 0 15-25.94c3-8.76 3.36-16.5 1.64-21-1.47-4.71-4.98-6.19-3.08-6.89z",
    className: "cls-3",
    clipPath: "url(#clipPath15758)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "M298.585 992.49c-.51.22-1 .44-1.5.68-.62 6.42-3.42 17.86-9.45 30.1-6.03 12.24-15 25.22-24.71 34.13-.13 2.53-.36 4.1-.35 4.1 8.49-2.28 15.89-7.59 22.44-15.17a81.8 81.8 0 0 0 15-25.94c3-8.76 3.36-16.5 1.64-21-1.46-4.72-4.97-6.2-3.07-6.9z",
    className: "cls-4",
    clipPath: "url(#clipPath15754)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "M275.035 1021.64c2.33-4.72 2.83-8.38 1.17-8.2-1.66.18-5.81 3.78-8 7.86-2.19 4.08-1.64 7.89-.16 8.29 1.48.4 4.66-3.23 6.99-7.95z",
    className: "cls-5",
    clipPath: "url(#clipPath15750)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "M346.945 789.65c.22-.44.44-.87.65-1.31a100.75 100.75 0 0 0 7.5-29.79c.51-7.36-.34-11.52-2.36-14.8-2.02-3.28-5.18-5.66-8.87-9.05-3.58-3.2-7.68-7.4-9.13-9.78-1.34-1.81-2.08-3-2.08-3-4.54 6.37-6.62 14.2-6.83 23.11a72.76 72.76 0 0 0 4.39 26.28c2.88 7.72 7 13.24 10.76 15.36 3.64 2.39 6.88 1.42 5.97 2.98z",
    className: "cls-3",
    clipPath: "url(#clipPath15746)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "M346.945 789.65c.22-.44.44-.87.65-1.31-3.21-4.76-7.75-14.2-10.54-26-2.79-11.8-4-25.78-2.33-37.41-1.34-1.81-2.08-3-2.08-3-4.54 6.37-6.62 14.2-6.83 23.11a72.76 72.76 0 0 0 4.39 26.28c2.88 7.72 7 13.24 10.76 15.36 3.65 2.38 6.89 1.41 5.98 2.97z",
    className: "cls-4",
    clipPath: "url(#clipPath15742)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "M346.635 756.31c1.07 4.56 2.79 7.36 3.84 6.29 1.05-1.07 1.85-5.88 1-9.9-.85-4.02-3.33-6.34-4.58-5.79-1.25.55-1.33 4.84-.26 9.4z",
    className: "cls-5",
    clipPath: "url(#clipPath15738)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "M320.335 318.23c-4 4.73-40 133.52-43.15 172.9-3.15 39.38 123.28 172.87 123.28 172.87z",
    className: "cls-6",
    clipPath: "url(#clipPath15734)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "M713.925 618.08s250.6 164.39 241.73 174.85c-8.87 10.46-73.57-36.11-73.57-36.11s83.78 77.52 67.75 86.06c-16.03 8.54-96.27-54.18-96.27-54.18s43.58 58.1 25.24 55.3c-18.34-2.8-212.92-207.39-212.92-207.39z",
    className: "cls-7",
    clipPath: "url(#clipPath15730)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse113",
    cx: -1108.791,
    cy: 9.83,
    className: "cls-8",
    clipPath: "url(#clipPath15726)",
    rx: 40.05,
    ry: 2.82,
    transform: "scale(-1 1) rotate(-40.38)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse115",
    cx: -1118.252,
    cy: -67.403,
    className: "cls-8",
    clipPath: "url(#clipPath15722)",
    rx: 31.02,
    ry: 2.82,
    transform: "scale(-1 1) rotate(-46.01)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "m437.765 850.22-6.25-43.07c-3.84 4.49-14.87-46.38-14.87-46.38s-131.39-125-102.91-401.9c7.85-76.36 12.47-119.47 12.47-119.47a15.75 15.75 0 0 1-12.93 1.49c-5.09-1.69 12.49-64.36 74.53-108.4 66.69-47.35 162.23-38.39 227.76 6.39 19.92 13.6 35.87 31.74 48.57 52.18 5.37 8.65-11.13 3.68-11.13 3.68s51.3 66.54 43.57 70c-6.74 3-21.52-2.49-21.88-2.62.93.93 91.91 92.57 179.55 256.83 0 0 117.38 183.61 89.63 181.82-13.11-.85-49.55-32.49-84.32-65.62 4.35 8.71 35.82 72.71 19.18 67.93-29-8.34-75-56.11-75.76-57.06a20.85 20.85 0 0 1-.3 2.64 207 207 0 0 1-36.57 91.2l-3.71 5.2-1.6 19.58-5.56 53.18-3.53 33.8s59.5 33.76 68.76 44.79c1.08 1.28 1.47 2.26 1 2.84-.47.58-1.93.87-4 .74-15.79-.91-70.32-21.12-70.32-21.12s10.82 64.49 4.6 67.6c-6.22 3.11-31.55-57.11-31.55-57.11s-48.8 39-52.17 30c-1-2.58 2.29-8.66 7.42-16 1-1.5 2.16-3 3.34-4.64 13.31-17.91 34.06-40.27 34.06-40.27l-18.34-35.06-15.14-28.93s-105.08 8.72-180.86-18.13c9.5 20.27 5.33 40 4.22 40.74-6 4-21.08-14.69-20.77-17.85l-4.79 48.67s25.35 17 42.44 31.31q2.27 1.91 4.32 3.74c6.7 6 11.27 11.16 10.93 13.89-1.19 9.55-57.68-17.1-57.68-17.1s-10.74 64.44-17.5 62.85c-6.76-1.59-11.14-66.83-11.14-66.83s-62.06 41.37-67.62 37c-5.56-4.37 56.85-62.53 56.85-62.53z",
    className: "cls-6",
    clipPath: "url(#clipPath15718)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "M406.085 165.06c13.93-5.06 30.75-4.13 45.09-.85 12 2.75 22.06 8.81 32 14.7l.16.09a34 34 0 0 0 33.72 0l.16-.09c10-5.89 20-12 32-14.7 14.34-3.28 31.16-4.22 45.09.85 30.85 11.21 24 50.46 24 50.46s-9.21 78.5-118.19 78.83c-108.85-.35-118.08-78.83-118.08-78.83s-6.8-39.25 24.05-50.46z",
    className: "cls-7",
    clipPath: "url(#clipPath15714)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "M380.885 912.7c5.57 4.37 67.62-37 67.62-37s4.37 65.24 11.14 66.83c6.77 1.59 17.5-62.85 17.5-62.85s56.49 26.65 57.68 17.1c.34-2.73-4.22-7.89-10.93-13.89q-2-1.83-4.32-3.74c-17.09-14.36-42.44-31.31-42.44-31.31l4.79-48.67-58.19-8 14 59.05s-62.43 58.1-56.85 62.48z",
    className: "cls-9",
    clipPath: "url(#clipPath15710)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "M460.445 928.78c1.33.37 2.34 2.37 2.48 4.06.24 2.81.47 7.11-2.55 8.61-2.87 1.42-3.38-5.09-3.46-6.61a7.81 7.81 0 0 1 1.06-4.75c.86-1.19 1.71-1.51 2.47-1.31z",
    className: "cls-10",
    clipPath: "url(#clipPath15706)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "M380.615 911.31c-.42-1.31.71-3.25 2.05-4.3 2.22-1.73 5.7-4.28 8.61-2.57 2.91 1.71-2.42 5.62-3.64 6.51a7.82 7.82 0 0 1-4.56 1.7c-1.48-.05-2.22-.6-2.46-1.34z",
    className: "cls-10",
    clipPath: "url(#clipPath15702)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m527.225 895.41-.23-.16a7.8 7.8 0 0 1-3.05-3.78c-.41-1.43-.13-2.3.5-2.76 1.11-.81 3.31-.35 4.72.59a18.63 18.63 0 0 1 3.81 3.13 4.85 4.85 0 0 1 1.34 4.23c-.63 2.96-5.53-.17-7.09-1.25z",
    className: "cls-10",
    clipPath: "url(#clipPath15698)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle129",
    cx: -577.095,
    cy: 203.66,
    r: 28.33,
    className: "cls-5",
    clipPath: "url(#clipPath15694)",
    transform: "scale(-1 1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle131",
    cx: -420.155,
    cy: 203.66,
    r: 28.33,
    className: "cls-5",
    clipPath: "url(#clipPath15690)",
    transform: "scale(-1 1)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "circle133",
    cx: -577.095,
    cy: 203.66,
    r: 19.69,
    className: "cls-11",
    clipPath: "url(#clipPath15686)",
    transform: "scale(-1 1)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "circle135",
    cx: -582.695,
    cy: 194.43,
    r: 3.57,
    className: "cls-5",
    clipPath: "url(#clipPath15682)",
    transform: "scale(-1 1)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "circle137",
    cx: -574.605,
    cy: 202.59,
    r: 2.49,
    className: "cls-5",
    clipPath: "url(#clipPath15678)",
    transform: "scale(-1 1)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "circle139",
    cx: -420.155,
    cy: 203.66,
    r: 19.69,
    className: "cls-11",
    clipPath: "url(#clipPath15674)",
    transform: "scale(-1 1)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "circle141",
    cx: -414.555,
    cy: 194.43,
    r: 3.57,
    className: "cls-5",
    clipPath: "url(#clipPath15670)",
    transform: "scale(-1 1)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "circle143",
    cx: -422.645,
    cy: 202.59,
    r: 2.49,
    className: "cls-5",
    clipPath: "url(#clipPath15666)",
    transform: "scale(-1 1)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path145",
    d: "m469.265 237.29 2.54 1.42c6.87 3.86 25.35 14.28 25.35 14.64 0-.36 18.14-10.59 25.15-14.53l2.73-1.53-.83-1.09c-3.49-4.47-17.18-21.23-27-21.85-8.85.47-23.25 17.28-27 21.82-.62.71-.94 1.12-.94 1.12z",
    className: "cls-9",
    clipPath: "url(#clipPath15662)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "m469.265 237.29 2.54 1.42a94.86 94.86 0 0 0 50.5.11l2.73-1.53-.83-1.09a92.49 92.49 0 0 1-54 0c-.62.68-.94 1.09-.94 1.09z",
    className: "cls-11",
    clipPath: "url(#clipPath15658)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path149",
    d: "M326.795 232s-29.84 53.8-23.47 59c6.37 5.2 30.23-17.11 30.23-17.11z",
    className: "cls-6",
    clipPath: "url(#clipPath15654)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path151",
    d: "M409.305 395.27c9.31-9.95 21.76-17.86 35.68-18.38 21.36-.79 31 13.27 44.39 26.9 15.22 15.45 26 13 40.19-.92 25.23-24.79 57.15-19 77.92 8.42 44.66 58.88 41.14 227-48.26 250-69.53 17.85-129.78-55-153-111.6-16.91-41.11-30.74-118.29 3.08-154.42z",
    className: "cls-7",
    clipPath: "url(#clipPath15650)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "M668.035 919.33c3.37 9 52.17-30 52.17-30s25.34 60.22 31.55 57.11c6.21-3.11-4.6-67.6-4.6-67.6s54.51 20.24 70.3 21.16l3-3.58c-9.25-11-68.76-44.79-68.76-44.79l3.53-33.8c-1.09-1.23 1.89-12.09 2.83-13.43 23.36-33.16-18.91-34.31-34.87-31.81-8.87 1.39-27.89 25-34.56 39.56l24.2 46.26s-20.75 22.35-34.06 40.27c-1.18 1.59-2.3 3.13-3.34 4.64-5.13 7.35-8.39 13.43-7.39 16.01z",
    className: "cls-9",
    clipPath: "url(#clipPath15646)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "M748.395 935.23c1.37.15 2.69 2 3.1 3.61.69 2.73 1.61 6.94-1.13 8.91-2.74 1.97-4.16-4.48-4.48-6a7.82 7.82 0 0 1 .28-4.85c.66-1.29 1.45-1.75 2.23-1.67z",
    className: "cls-10",
    clipPath: "url(#clipPath15642)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "m668.695 914.71.17-.22a7.8 7.8 0 0 1 4-2.82c1.45-.33 2.3 0 2.73.67.74 1.16.16 3.33-.87 4.68a18.63 18.63 0 0 1-3.35 3.62 4.85 4.85 0 0 1-4.3 1.09c-2.96-.82.45-5.53 1.62-7.02z",
    className: "cls-10",
    clipPath: "url(#clipPath15638)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "M809.615 894c.88-1.06 3.12-1.15 4.72-.58 2.65.94 6.68 2.5 6.8 5.87.11 3.2-6 1-7.45.43a7.82 7.82 0 0 1-3.89-2.92c-.76-1.26-.68-2.18-.18-2.8z",
    className: "cls-10",
    clipPath: "url(#clipPath15634)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "M701.145 755.78s24.49 71.58 31.52 67.66c7.03-3.92 3.39-59 3.39-59z",
    className: "cls-6",
    clipPath: "url(#clipPath15630)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "m763.105 737.85.74 2.94s6.24 75.87-5.77 75.28c-12.01-.59-29.57-58.83-29.57-58.83z",
    className: "cls-6",
    clipPath: "url(#clipPath15626)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "M685.155 748.61s17.51 73.6 24.88 70.39c7.37-3.21 9-58.41 9-58.41z",
    className: "cls-6",
    clipPath: "url(#clipPath15622)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "M704.355 768.37s-14.6 50-19.3 47.73c-4.7-2.27-9.43-39.1-9.43-39.1z",
    className: "cls-6",
    clipPath: "url(#clipPath15618)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "m416.935 752.42 13.86 6.72s.28 1.37.55 3.65l11.82 4.76 14.54-.73c-.9-3.95-1.42-6.46-1.42-6.46l27.31 10.64s-1.37 47.68-9.41 44.16c-3-1.31-6.65-11.28-9.88-22.36-1.22 10.68-3.1 20.24-5.91 18.84-3.4-1.69-7.54-9.49-10.92-21.13-1.55 12.28-5.13 21.46-11 19-3.84-1.58-6.58-9.64-8.5-18.82a28.19 28.19 0 0 1-10.06 12c-7.59 4.15-.98-50.27-.98-50.27z",
    className: "cls-6",
    clipPath: "url(#clipPath15614)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "M688.735 390.17c-.19 0-.56.86-1.11 2.64a74.09 74.09 0 0 0-1.86 7.9c-.27 1.74-.63 3.67-.88 5.81-.25 2.14-.53 4.45-.67 7s-.25 5.19-.33 8v4.39c0 1.51.12 3 .18 4.63a177.22 177.22 0 0 0 8.2 43.58 243.06 243.06 0 0 0 9.35 24.47c3.7 8.29 7.92 16.69 12.59 25.08 4.67 8.39 9.51 16.4 14.35 24 4.84 7.6 9.65 14.87 14.39 21.68 4.74 6.81 9.38 13.19 13.86 19.05 4.48 5.86 8.8 11.21 12.83 16 8.1 9.59 15.09 17 20.1 21.88 1.26 1.22 2.37 2.31 3.37 3.23 1 .92 1.85 1.67 2.56 2.27 1.41 1.2 2.22 1.76 2.36 1.63.14-.13-.39-1-1.54-2.42-.57-.73-1.29-1.61-2.16-2.63l-3-3.56c-4.49-5.34-11-13.06-18.61-22.89-3.8-4.93-7.89-10.38-12.18-16.31-4.29-5.93-8.74-12.36-13.32-19.19-4.58-6.83-9.26-14.1-14-21.7s-9.5-15.54-14.1-23.82c-4.6-8.28-8.79-16.51-12.48-24.6-3.69-8.09-6.83-16.09-9.45-23.82a190.24 190.24 0 0 1-9.16-42.26c-.12-1.54-.3-3-.37-4.5l-.24-4.28c-.06-2.78-.17-5.4-.1-7.86s.12-4.74.19-6.85c.07-2.11.28-4 .38-5.75.34-3.45.59-6.14.8-8 .21-1.86.24-2.76.05-2.8z",
    className: "cls-8",
    clipPath: "url(#clipPath15610)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "M609.485 504.32c.7.14 1.66-1 2.31-3.19a16.31 16.31 0 0 0 .63-3.9 20.79 20.79 0 0 0-1.83-9.43 16.31 16.31 0 0 0-2-3.38c-1.42-1.77-2.74-2.48-3.34-2.09-.6.39-.47 1.81 0 3.76.22 1 .49 2.1.79 3.34.3 1.24.59 2.58.87 4s.49 2.78.69 4c.2 1.22.36 2.4.52 3.39.25 1.99.62 3.35 1.36 3.5z",
    className: "cls-5",
    clipPath: "url(#clipPath15606)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "M561.945 446.78c-.38.64 0 1.61.67 2.73a56.35 56.35 0 0 0 6 7.39c1 .9 1.84 1.45 2.54 1.2s1-1.28.85-2.82a11.71 11.71 0 0 0-7.17-8.78c-1.42-.5-2.52-.34-2.89.28z",
    className: "cls-5",
    clipPath: "url(#clipPath15602)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "M566.035 419.33c-.21.72.6 1.62 1.86 2.69.64.53 1.38 1.13 2.2 1.76l2.61 2.07 2.61 2.15c.79.67 1.52 1.28 2.17 1.79 1.31 1 2.36 1.63 3 1.27.64-.36.73-1.64 0-3.45a12.58 12.58 0 0 0-1.62-2.92 16.31 16.31 0 0 0-6.3-5.11 12.58 12.58 0 0 0-3.19-1c-1.84-.3-3.1.07-3.34.75z",
    className: "cls-5",
    clipPath: "url(#clipPath15598)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "M593.715 533.42c.53.47 1.82.09 3.25-1.31a9 9 0 0 0 1.05-1.24 12.17 12.17 0 0 0 1-1.58 14.27 14.27 0 0 0 1.45-8.3 12.18 12.18 0 0 0-.39-1.82 9 9 0 0 0-.57-1.52c-.87-1.81-2-2.6-2.62-2.34-.62.26-.91 1.47-1.07 3.08l-.26 2.73c-.12 1-.25 2.08-.44 3.21s-.44 2.18-.67 3.17l-.68 2.66c-.41 1.57-.62 2.76-.05 3.26z",
    className: "cls-5",
    clipPath: "url(#clipPath15594)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "M572.635 522.31c.59.41 1.71 0 2.86-1.21a9.66 9.66 0 0 0 1.62-2.43 12.59 12.59 0 0 0 1.08-7 9.67 9.67 0 0 0-.8-2.81c-.73-1.53-1.68-2.23-2.36-2-.68.23-1.08 1.23-1.36 2.59-.13.68-.26 1.46-.38 2.3l-.4 2.69-.44 2.68c-.14.83-.25 1.62-.33 2.31-.14 1.38-.09 2.46.51 2.88z",
    className: "cls-5",
    clipPath: "url(#clipPath15590)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "M599.225 438.72c-.4.63-.1 1.59.48 2.7s1.42 2.4 2.36 3.81c.94 1.41 1.78 2.69 2.58 3.66.8.97 1.56 1.61 2.29 1.49.73-.12 1.26-1.06 1.3-2.59a8.45 8.45 0 0 0-.38-2.6 11.15 11.15 0 0 0-3.49-5.28 8.45 8.45 0 0 0-2.25-1.36c-1.41-.55-2.5-.44-2.89.17z",
    className: "cls-5",
    clipPath: "url(#clipPath15586)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "M587.305 454.1c-.41.63-.05 1.62.62 2.81s1.66 2.59 2.74 4.13c1.08 1.54 2.05 2.94 2.93 4 .88 1.06 1.7 1.71 2.42 1.55.72-.16 1.18-1.2 1.12-2.82a9.63 9.63 0 0 0-.55-2.74 12.74 12.74 0 0 0-3.86-5.53 9.64 9.64 0 0 0-2.39-1.5c-1.5-.6-2.64-.51-3.03.1z",
    className: "cls-5",
    clipPath: "url(#clipPath15582)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "M579.495 478.16c-.64.38-.72 1.51-.55 3 .17 1.49.59 3.4 1.06 5.48.47 2.08.92 4 1.41 5.4.49 1.4 1.05 2.41 1.79 2.48.74.07 1.5-.85 2-2.51a14.58 14.58 0 0 0-2.83-12.44c-1.17-1.29-2.26-1.78-2.88-1.41z",
    className: "cls-5",
    clipPath: "url(#clipPath15578)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse189",
    cx: -159.008,
    cy: -494.987,
    className: "cls-8",
    clipPath: "url(#clipPath15574)",
    rx: 7.189,
    ry: 1.958,
    style: {
      strokeWidth: 1.00404
    },
    transform: "scale(-1 1) rotate(-84.857)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "M486.525 110.9c-.4.36-.3 1.19.1 2.25a30 30 0 0 0 4.36 7.2c.76.84 1.44 1.32 2 1.13.56-.19.72-1 .57-2.24a12.45 12.45 0 0 0-4.73-7.81c-1.06-.69-1.91-.88-2.3-.53z",
    className: "cls-8",
    clipPath: "url(#clipPath15570)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse193",
    cx: -538.184,
    cy: -29.063,
    className: "cls-8",
    clipPath: "url(#clipPath15566)",
    rx: 1.95,
    ry: 5.58,
    transform: "scale(-1 1) rotate(-17.63)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse195",
    cx: -531.152,
    cy: 46.645,
    className: "cls-8",
    clipPath: "url(#clipPath15562)",
    rx: 1.95,
    ry: 5.43,
    transform: "scale(-1 1) rotate(-12.12)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse197",
    cx: -342.881,
    cy: -371.626,
    className: "cls-8",
    clipPath: "url(#clipPath15558)",
    rx: 5,
    ry: 1.95,
    transform: "scale(-1 1) rotate(-64.27)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse199",
    cx: -302.002,
    cy: -392.178,
    className: "cls-8",
    clipPath: "url(#clipPath15554)",
    rx: 3.6,
    ry: 1.95,
    transform: "scale(-1 1) rotate(-67.26)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse201",
    cx: -164.04,
    cy: -487.747,
    className: "cls-8",
    clipPath: "url(#clipPath15550)",
    rx: 4.2,
    ry: 1.95,
    transform: "scale(-1 1) rotate(-87.06)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse203",
    cx: -515.584,
    cy: 72.245,
    className: "cls-8",
    clipPath: "url(#clipPath15546)",
    rx: 2.22,
    ry: 4.5,
    transform: "scale(-1 1) rotate(-10.19)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path205",
    d: "M326.395 553.12c.37-.11 0-2.75-.88-7.41l-.8-3.87-.89-4.61c-.63-3.31-1.47-7-2.18-11.22l-1.21-6.53c-.42-2.27-.77-4.65-1.18-7.1-.41-2.45-.87-5-1.21-7.61l-1.16-8.08c-1.45-11.08-2.75-23.29-3.6-36.15-.85-12.86-1-25.14-1-36.31l.13-8.16c0-2.65.17-5.21.24-7.7.07-2.49.15-4.89.28-7.19l.38-6.63c.18-4.23.54-8 .75-11.4l.3-4.69.3-3.94c.32-4.74.32-7.4-.07-7.46-.39-.06-1.12 2.49-2.11 7.16q-.37 1.75-.79 3.9c-.26 1.43-.5 3-.77 4.66-.51 3.35-1.15 7.17-1.59 11.41l-.75 6.66c-.25 2.32-.4 4.74-.61 7.24-.21 2.5-.44 5.09-.53 7.77l-.37 8.25c-.33 11.3-.24 23.74.55 36.77.79 13.03 2.34 25.38 4.09 36.55l1.41 8.14c.43 2.64 1 5.18 1.51 7.64s1 4.84 1.52 7.11l1.58 6.52c1 4.16 2.09 7.86 3 11.12.48 1.63.91 3.14 1.35 4.53.44 1.39.89 2.64 1.28 3.76 1.61 4.54 2.67 6.98 3.03 6.87z",
    className: "cls-8",
    clipPath: "url(#clipPath15542)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "M782.515 498.92c-1.32 1 17 27 36.84 60.78 19.84 33.78 33.84 62.34 35.35 61.66.68-.31-1.92-7.89-7.18-19.71l-2.09-4.62c-.74-1.6-1.54-3.25-2.36-5-1.63-3.44-3.47-7.06-5.41-10.87-3.93-7.59-8.44-15.85-13.45-24.36s-10.06-16.44-14.8-23.56c-2.4-3.54-4.67-6.91-6.9-10-1.1-1.55-2.16-3-3.21-4.47l-3-4.07c-7.82-10.27-13.19-16.22-13.79-15.78z",
    className: "cls-8",
    clipPath: "url(#clipPath15538)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenOwl);
export default __webpack_public_path__ + "static/media/hiddenOwl.f37db1eeb10f331761194070a7f7b46b.svg";
export { ForwardRef as ReactComponent };